module.exports = __webpack_public_path__ + "static/img/ico_vip_24-24.a93d5fc6.svg";